const firebaseConfig = {
    apiKey: "AIzaSyD73tSFgB6zMq8OLCyxJYyRv8HCV9IOoxU",
    authDomain: "ema-john-simple-702e1.firebaseapp.com",
    projectId: "ema-john-simple-702e1",
    storageBucket: "ema-john-simple-702e1.appspot.com",
    messagingSenderId: "1083468821832",
    appId: "1:1083468821832:web:0c5647fb9460fd5aacef7d"
  };
export default firebaseConfig;